import React from 'react';
import SoftAlert from './SoftAlert';
import LoudAlert from './LoudAlert';
import {AlertType, AlertPropTypes} from './types';

export {validTypeValues, validVariationValues, validBackgroundValues} from './types';
export type {AlertType};

const Alert: React.FC<AlertType> = props => {
  if (props.variation === 'soft') {
    return <SoftAlert {...props} />;
  }
  return <LoudAlert {...props} />;
};

Alert.displayName = 'Alert';

Alert.propTypes = AlertPropTypes;

export default Alert;
